import { TopTen } from "$gql/queries/general/TopTen.gen";
import classNames from "classnames";
import Link from "next/link";
import React from "react";
import { useQueryBundle } from "source/hooks";
import styles from "./Top10Section.module.scss";

type Props = {
  results: {
    brandName: string;
    tickerSymbol: string;
  }[];
};

const Top10Section = (props: Props) => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>Top 5 Requested Brands</p>
      {props.results.length === 0 ? (
        <>
          <div className={styles.row}>
            {Array.from({ length: 5 }).map((_, i) => (
              <div className={styles.nameContainer}>
                <div className={styles.empty} key={`empty-result-${i}`} />
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className={styles.row}>
            {props.results.slice(0, 5).map((top) => (
              <Link
                key={`top-ten-${top.tickerSymbol}`}
                href={`brand/${top.tickerSymbol}`}
              >
                <a className={styles.nameContainer}>
                  <p className={styles.companyName}>{top.brandName}</p>
                </a>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Top10Section;
